(function () {
  if (customElements.get('sticky-element')) return;

  class StickyElement extends HTMLElement {
    constructor() {
      super();
      this.endScroll = window.innerHeight - this.offsetHeight - 500;
      this.currPos = window.scrollY;
      this.screenHeight = window.innerHeight;
      this.stickyElementHeight = this.offsetHeight;
      this.bottomGap = this.offsetHeight < window.innerHeight ? this.topGap : 0;
      this.ticking = false;

      window.addEventListener('scroll', this.onScrollHandler.bind(this), {
        capture: true,
        passive: true,
      });
    }

    get headerHeight() {
      let header = document.querySelector('sticky-header, header[is="sticky-header"], .header-wrapper');
      if (this.hasAttribute('aria-controls')) {
        header = document.getElementById(this.getAttribute('aria-controls'));
      }
      return header
        ? header.getBoundingClientRect().height + this.topGap
        : this.offsetHeight < window.innerHeight
        ? this.topGap
        : 0;
    }

    get topGap() {
      return this.hasAttribute('data-gap') ? parseInt(this.getAttribute('data-gap'), 10) : 20;
    }

    get inset() {
      return parseFloat(this.style.getPropertyValue('--inset')) || 0;
    }

    onScrollHandler() {
      if (this.ticking) return;
      requestAnimationFrame(() => {
        var style = window.getComputedStyle(this);
        if (style.position === 'sticky') {
          this.screenHeight = window.innerHeight;
          this.stickyElementHeight = this.offsetHeight;
          this.positionStickySidebar();
        }
        this.ticking = false;
      });
      this.ticking = true;
    }

    positionStickySidebar() {
      this.endScroll = window.innerHeight - this.offsetHeight - this.bottomGap;
      var stickyElementTop = this.inset;
      var scrollDelta = this.currPos - window.scrollY;

      if (this.stickyElementHeight + this.headerHeight + this.bottomGap > this.screenHeight) {
        var newInset;
        if (window.scrollY < this.currPos) {
          if (stickyElementTop < this.headerHeight) {
            newInset = Math.min(stickyElementTop + scrollDelta, this.headerHeight);
          } else {
            newInset = this.headerHeight;
          }
        } else if (stickyElementTop > this.endScroll) {
          newInset = Math.max(stickyElementTop + scrollDelta, this.endScroll);
        } else {
          newInset = this.endScroll;
        }

        if (Math.abs(newInset - stickyElementTop) > 0.5) {
          this.style.setProperty('--inset', newInset.toFixed(1) + 'px');
        }
      } else {
        this.style.setProperty('--inset', this.headerHeight.toFixed(1) + 'px');
      }

      this.currPos = window.scrollY;
    }
  }

  customElements.define('sticky-element', StickyElement);
})();
